/* src/app/modules_v2/contacts/components/contact-auto-distribution/contact-auto-distribution.component.css */
.cad {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cad-hint {
  margin: 0;
  color: var(--cf-text-muted, #6b7280);
  font-size: 0.85rem;
}
.cad-project {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  padding: 8px 12px;
}
.cad-project__head,
.cad-grant {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.cad-project__name {
  font-weight: 600;
}
.cad-grant {
  padding-left: 16px;
  border-left: 3px solid var(--cf-accent, #a8d600);
}
.cad-grant small,
.cad-project__head small {
  color: var(--cf-text-muted, #6b7280);
}
.cad-grant__value {
  width: 130px;
}
.cad-total {
  text-align: right;
  font-size: 0.85rem;
  color: var(--cf-text-muted, #6b7280);
}
.cad-total--bad {
  color: #b91c1c;
  font-weight: 600;
}
.cad-warn {
  color: #b91c1c;
  font-size: 0.85rem;
}
.cad-actions {
  display: flex;
  justify-content: flex-end;
}
.cad-error {
  display: flex;
  align-items: center;
  gap: 12px;
}
/*# sourceMappingURL=contact-auto-distribution.component.css.map */
